<template>
	<div class="mogine_home_main">
		<!-- <mHeader></mHeader> -->
		<div class="swiper-banner-box">
			<swiper :options="swiperOption" class="banner_swiper" ref="swiper">
				<swiper-slide v-for="(item,index) in swiperOption.list" :key="index">
					<div class="banner_img_box" :class="{ firstBanner: !index }" @click="onTry(item.path)">
						<img :src="item.img" alt="" class="index-banner">
						<div class="banner_text_box">
							<div class="banner_en_text">{{ item.enText || 'Mogine Hub' }}</div>
							<div class="banner_text">{{ item.text || '摩镜视界' }}</div>
							<div class="banner_des">{{ $t(item.des) || $t('home.banner_default_des') }}</div>
							<div class="banner_btn">{{ $t(item.btnText) || $t('home.banner_btn_text') }}</div>
						</div>
					</div>
				</swiper-slide>
			</swiper>
			<swiperBar :current="swiperIndex" :length="swiperOption.list.length" @change="onSwiperBarChange"></swiperBar>
		</div>
		<div class="content_title">Idea Pod 灵感仓</div>
		<div class="mogine_home_content_1">
			<div class="mogine_home_content_1_text">
				<div class="mogine_home_content_en_text">MASSIVE ASSETS</div>
				<div class="mogine_home_content_cn_text">海量USD资产</div>
			</div>
			<div class="mogine_home_content_1_img_list">
				<img v-for="index in 16" :key="index" class="mogine_home_content_1_img" :src="`https://mogine.oss-cn-shanghai.aliyuncs.com/direct/mofine_home_resource_${index}.png`" alt="">
			</div>
		</div>
		<div class="mogine_home_content_2">
			<div class="home_content_2_item">
				<img src="https://mogine.oss-cn-shanghai.aliyuncs.com/direct/mogine_wecome_img_2_1.png" alt="" class="content_img">
				<div class="home_content_2_item_title">{{ $t('home.content_1_title') }}</div>
				<div class="home_content_2_item_des">{{ $t('home.content_1_des') }}</div>
			</div>
			<div class="home_content_2_item">
				<img src="https://mogine.oss-cn-shanghai.aliyuncs.com/direct/mogine_wecome_img_2_2.png" alt="" class="content_img">
				<div class="home_content_2_item_title">{{ $t('home.content_2_title') }}</div>
				<div class="home_content_2_item_des">{{ $t('home.content_2_des') }}</div>
			</div>
			<div class="home_content_2_item">
				<img src="https://mogine.oss-cn-shanghai.aliyuncs.com/direct/mogine_wecome_img_2_3.png" alt="" class="content_img">
				<div class="home_content_2_item_title">{{ $t('home.content_3_title') }}</div>
				<div class="home_content_2_item_des">
					<p>{{ $t('home.content_3_des_1') }}</p>
					<p>{{ $t('home.content_3_des_2') }}</p>
				</div>
			</div>
		</div>
		
		<div class="list_content_box">
			<div class="list_title">媒体看摩泛</div>
			<div class="list_content">
				<div class="list_box" v-if="info.length">
					<div class="news_main" @click="onNewsClick(info[0])">
						<img :src="info[0].coverImg" alt="" class="news_cover" />
						<div class="news_info">
							<div class="news_title">{{ info[0].title }}</div>
							<div class="news_date">{{ info[0].subtitle }}</div>
						</div>
					</div>
					<div class="news_list">
						<div class="news_item" v-for="index in 3" :key="index" @click="onNewsClick(info[index])">
							<img :src="info[index].coverImg" alt="" class="news_cover" />
							<div class="news_info">
								<div class="news_title">{{ info[index].title }}</div>
								<div class="news_date_box">
									<div class="news_date">{{ info[index].subtitle }}</div>
									<img src="@/assets/news/Open.png" alt="" class="more_icon" />
								</div>
							</div>
						</div>
					</div>	
				</div>
				<div class="more_text">
					<router-link to="/media" class="more_btn">更多</router-link>
				</div>
			</div>
			
		</div>
		
		
		<div class="pc_box">
			<div class="content_title">{{ $t('home.content_title') }}</div>
			<div class="content_des">{{ $t('home.content_des') }}</div>
			<div class="content_btn" @click="onLink('/download')">{{ $t('home.cotnent_btn') }}</div>
			<video class="content_img content_video" controls>
				<source src="https://mogine.oss-cn-shanghai.aliyuncs.com/direct/mofine_home_video.mp4" type="video/mp4">
				Your browser does not support the video tag.
			</video>
		</div>
		<friends></friends>
		<mfooter></mfooter>
	</div>
</template>

<script>
	import friends from '@/components/index/friends.vue'
	import mfooter from '@/components/footer.vue'
	import swiperBar from '@/components/swiper/swiper_bar.vue'
	import api from '@/api/api.js'
	export default {
		name: 'home',
		components: { mfooter, friends, swiperBar },
		data: function () {
			return {
				swiperOption: {
					loop: true,
					speed: 2000,
					allowTouchMove: false,
					autoplay: true,
					on: {
						slideChangeTransitionStart: (params) => {	
							if(this.$refs.swiper.swiper){
								this.swiperIndex = this.$refs.swiper.swiper.realIndex
							}
						}
					},
					list: [
						{
							img: 'https://mogine.oss-cn-shanghai.aliyuncs.com/direct/mofine_index_3DWorld.png',  
							enText: 'Mogine Lab',
							text: '摩镜视界',
							des: 'home.banner_1_des',
							btnText: 'home.banner_1_btn_text',
							path: '/lab/index'
						},
						{ img: 'https://mogine.oss-cn-shanghai.aliyuncs.com/direct/mogine_index_banner_2.png' },
						{ img: 'https://mogine.oss-cn-shanghai.aliyuncs.com/direct/mogine_index_banner_0.jpg' },
						// { img: 'https://mogine.oss-cn-shanghai.aliyuncs.com/direct/mogine_index_banner_3.png' },
						// { img: 'https://mogine.oss-cn-shanghai.aliyuncs.com/direct/mogine_index_banner_4.png' },
						{ img: 'https://mogine.oss-cn-shanghai.aliyuncs.com/direct/mogine_index_banner_5.png' },
						
						
					],
				},
				swiperIndex: 0,
				swiper2Option: {
					loop: true,
					navigation: {
					      nextEl: '.swiper-button-next',
					      prevEl: '.swiper-button-prev',
					    },
				},
				info: [],
			}
		},
		created() {
			this.getNewsList()
		},
		methods: {
			$i(str) {
				return this.$t(`news.${str}`)
			},
			onNewsClick(news) {
				switch (news.linkType) {
					case 1:
						this.$router.push(`/media/detail?id=${news.id}`)
					break
					case 2:
						window.open(news.linkUrl)
					break;
				}
			},
			onTry(url) {
				if (url == '/lab/index') {
					this.$router.push(url || '/download')
				} else {
					window.location.href = 'Mogine://';
					setTimeout(() => {
					    if (!document.hasFocus()) {
					        // 如果窗口失去焦点，说明应用已经打开
					        return;
					    }
					    // 如果代码执行到这里，说明应用可能没有打开
					    // var userResponse = confirm("It seems the Mogine app is not installed on your computer. Would you like to download it?");
						// this.$message.default("敬请期待")
						this.$router.push(url || '/download')
					    // if (userResponse) {
					    //     // 这里可以替换为应用的下载链接
					    //     window.location.href = 'https://download-link-for-mogine-app.com';
					    // }
					}, 500);
				}
				
			},
			onSwiperBarChange(index) {
				this.$refs.swiper.swiper.slideTo(index)
			},
			async getNewsList() {
				let res = await api.news({ current: 1, size: 4 , newsType: 1})
				console.log(res.data.records)
				this.info = res.data.records
			}
			
		}
	}
</script>

<style scoped lang="less">
	.mogine_home_main{
		background-color: #000;
		padding-top: 80px;
		.swiper-banner-box{
			position: relative;
			z-index: 100;
		}
		.banner_swiper{
			width: 100%;
			height: 7.55rem;
			position: relative;
			.banner_img_box{
				width:100%;
				height: 7.55rem;
				position: relative;
				cursor: pointer;
				&.firstBanner{
					.theme3-border(8px)
				}
				.banner_text_box{
					position: absolute;
					bottom: 79px;
					left: 96px;
					color: #fff;
					z-index: 1;
					.banner_en_text{
						font-size: 40px;
						font-weight: bold;
						line-height: 56px;
					}
					.banner_text{
						font-size: 60px;
						font-weight: 900;
						line-height: 72px;
						margin-bottom: 23px;
					}
					.banner_des{
						font-size: 32px;
						font-weight: 400;
						line-height: 40px;
						margin-bottom: 57px;
					}
					.banner_btn{
						width: 318px;
						height: 80px;
						line-height: 80px;
						color: #fff;
						text-align: center;
						font-size: 24px;
						border-radius: 40px;
						background: @theme3-color;
						cursor: pointer;
					}
				}
				
			}
			.index-banner{
				width:100%;
				height: 8.35rem;
				object-fit: cover;
			}
			
		}
		.content_title{
			text-align: center;
			font-size: 40px;
			color: #fff;
			margin-top: 80px;
			margin-bottom: 60px;
		}
		.content_img{
			width: 100%;
			display: block;
			margin: 0 auto;
			max-width: 100%;
		}
		.content_video{
			width: 1440px;
			max-width: 80%;
		}
		.swiper_box{
			width: 1224px;
			margin: 0 auto;
			position: relative;
			.swiper-button-prev{
				left: -48px;
				background-image: url(@/assets/wecome/swiper_prev.png);
				background-size: 32px;
			}
			.swiper-button-next{
				right: -48px;
				background-image: url(@/assets/wecome/swiper_next.png);
				background-size: 32px;
			}
		}
		.creater_box{
			display: none;
		}
		.create_swiper{
			width: 100%;
			.create_box{
				width: 1224px;
				display: flex;
				.create_img{
					width: 916px;
					height: 515px;
				}
				.create_text_box{
					width: 308px;
					height: 515px;
					padding: 32px;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					.create_text{
						font-size: 12px;
						line-height:18px;
						color: #ABAEB4;
						white-space: pre-wrap;
					}
					.create_user_info{
						display: flex;
						.create_user_img{
							width: 50px;
							height:50px;
							border-radius: 25px;
							margin-right: 16px;
						}
						.create_user_info_box{
							.create_user_name{
								font-size: 14px;
								line-height: 20px;
								color: #e1e1e2;
							}
							.user_des{
								font-size: 12px;
								color: #687382;
							}
						}
					}
				}
				
			}
		}
		.content_des{
			font-size: 20px;
			line-height:28px;
			margin-bottom: 55px;
			color: #fff;
			text-align:  center;
		}
		.content_btn{
			width: 318px;
			height: 80px;
			line-height: 80px;
			text-align: center;
			font-size: 24px;
			background: @theme3-color;
			border-radius: 40px;
			margin: 0 auto;
			color: #fff;
			margin-bottom: 55px;
			cursor: pointer;	
		}
		.friend_list{
			padding-top: 200px;
			text-align: center;
			color: #fff;
			.title{
				font-size: 40px;
				line-height: 56px;
				margin-bottom: 80px;
			}
			.friend_logos{
				width: 1019px;
				display: flex;
				justify-content: space-between;
				margin: 0 auto;
				.logo_img{
					width: 199px;
					height: 199px;
				}
			}
		}
		.mogine_home_content_1{
			display: flex;
			padding: 0 .40rem;
			margin-bottom: .16rem;
			.mogine_home_content_1_text {
				width: 3rem;
				flex: 0 0 auto;
				color: #fff;
				margin-right: .40rem;
				padding-top: .64rem;
				.mogine_home_content_en_text {
					font-size: .32rem;
					line-height: .4rem;
					margin-bottom: .04rem;
				}
				.mogine_home_content_cn_text{
					font-size: .24rem;
					line-height: .48rem;
				}
			}
			.mogine_home_content_1_img_list {
				display: flex;
				flex-wrap: wrap;
				.mogine_home_content_1_img {
					width: 1.6rem;
					height: 1.6rem;
					margin-right: .16rem;
					background: #0E0F10;
					margin-bottom: .16rem;
				}
			}
		}
		.mogine_home_content_2{
			display: flex;
			justify-content: space-between;
			padding: 0 .42rem;
			margin-bottom: .6rem;
			.home_content_2_item{
				width: 5.17rem;
				// height: 5.81rem;
				background: rgba(14, 15, 16, 1);
				display: flex;
				flex-direction: column;
				align-items: center;
				padding-top: .55rem;
				color: #fff;
				padding-bottom: .40rem;
				.content_img{
					height: 2.65rem;
					margin-bottom: .89rem;
					width: auto;
				}
				.home_content_2_item_title{
					font-family: PingFang SC;
					font-size: .32rem;
					font-weight: 700;
					text-align: center;
					margin-bottom: .32rem;
				}
				.home_content_2_item_des{
					font-size: 14px;
					font-weight: 400;
					line-height: 20px;
					color: rgba(119, 124, 132, 1);

				}
				&:first-child {
					width: 7.73rem;
				}
			}
		}
		.list_content_box {
			width: 1440px;
			margin: 0 auto;
			// padding: 0 0.42rem;
			.list_title {
				font-size: 40px;
				line-height: 40px;
				color: #fff;
				text-align: center;
				margin-bottom: 18px;
			}
			.list_content{
				background: rgba(14, 15, 16, 1);
				display: flex;
				justify-content: center;
				padding: 0.6rem 0;
				flex-direction: column;
				align-items: center;
			}
		}
		.list_box{
			width: 100%;
			display: flex;
			justify-content: space-between;
			.news_main{
				width: 709px;
				cursor: pointer;
				.news_cover{
					width: 100%;
					height: 431px;
					border-radius: 10px 10px 0 0;
					display: block;
				}
				.news_info{
					height: 125px;
					padding: 22px 16px;
					background-color: #1A1A1A;
					.news_title{
						font-size: 16px;
						line-height: 40px;
						color: #fff;
					}
					.news_date{
						font-size: 16px;
						color: #878787;
					}
				}
			}
			.news_list{
				width: 710px;
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				.news_item {
					height: 172px;
					display: flex;
					border-radius: 0 10px 10px 0;
					overflow: hidden;
					margin-bottom: 20px;
					cursor: pointer;
					.news_cover{
						width: 282px;
						height: 172px;
						flex: 0 0 auto;
						object-fit: cover;
					}
					.news_info{
						width: 100%;
						padding: 26px 20px;
						background-color: #1A1A1A;
						.news_title{
							color: #fff;
							font-size: 16px;
							line-height: 40px;
						}
						.news_date_box{
							display: flex;
							justify-content: space-between;
							align-items: center;
							line-height: 40px;
							.news_date{
								font-size: 16px;
								color: #878787;
							}
							.more_icon{
								width: 20px;
								height: 20px;
								object-fit: cover;
							}
						}
					}
				}
			}
		}
		.more_text {
			width: 100%;
			display: flex;
			justify-content: flex-end;
			.more_btn {
				font-size: 18px;
				color: #fff;
				padding-left: 30px;
				background: url(@/assets/news/more.png) no-repeat left center;
				background-size:25px; 
			}
		}
	}
</style>

<style scoped lang="less">
	@media screen and (max-width: 760px) {
		.mogine_home_main{
			.swiper-banner-box{
				.banner_swiper{
					.banner_img_box{
						&.firstBanner{
							.theme3-border(2px)
						}
						.banner_text_box{
							left: 20px;
							bottom: 5px;
							.banner_en_text{
								font-size: 20px;
								transform: scale(.5) translateX(-50%);
								line-height: 10px;
								margin-bottom: 2px;
							}
							.banner_text{
								font-size: 15px;
								line-height: 15px;
								margin-bottom: 5px;
							}
							.banner_des{
								font-size:8px;
								line-height: 8px;
								// transform: scale(.5) translateX(-50%);
								margin-bottom: 0;
							}
							.banner_btn{
								display: none;
							}
						}
					}
				}
				.slide_bar{
					bottom: 9px;
					right: 17px;
					.slide-bar-item{
						width: 2px;
						height: 2px;
						margin-left: 4px;
						&:first-child{
							width: 10px;
							height: 2px;
						}
					}
					
				}
			}
			.content_title{
				font-size: 28px;
				font-weight: 400;
				line-height: 39px;
				margin-top: 36px;
				margin-bottom: 28px;
			}
			.mogine_home_content_1{
				margin-bottom: 50px;
				.content_img{
					width: 100%;
					display: block;
					margin-bottom: 28px;
				}
			}
			.mogine_home_content_2{
				display: block;
				.home_content_2_item{
					width: 100%;
					height: auto;
					padding-top: 31px;
					margin-bottom: 8px;
					padding-bottom: 50px;
					.content_img{
						width: 283px;
						height: 167px;
						object-fit: cover;
						margin-bottom: 51px;
						border-radius: 7px;
					}
					.home_content_2_item_title{
						font-size: 18px;
						margin-bottom: 21px;
					}
					.home_content_2_item_des{
						font-size: 16px;
						transform: scale(.5);
						white-space: nowrap;
						text-align: center;
					}
					&:first-child {
						width: 100%;
						.content_img{
							width: 330px;
							height: 152px;
						}
					}
				}
			}
			.swiper_box{
				display: none;
			}
			.creater_box{
				display: block;
				.creater_item{
					background: rgba(14, 15, 16, 1);
					color: #fff;
					margin-bottom: 20px;
					.creater_info{
						display: flex;
						justify-content: space-between;
						align-items: center;
						padding: 16px;
						.user_info{
							display: flex;
							align-items: center;
							.headImage{
								width: 56px;
								height: 56px;
								border-radius: 50%;
								margin-right: 16px;
							}
							.userName{
								font-size: 20px;
								line-height: 28px;
								text-align: left;
								font-size: 16px;
							}
						}
						
						.creater_des{
							font-size: 12px;
							line-height: 17px;
							letter-spacing: 0.01em;
							text-align: right;
							color: rgba(104, 115, 130, 1);
						}
					}
					.creater_img{
						width: 100%;
					}
					.creater_text_box{
						padding-bottom: 30px;
						position: relative;
						&:after{
							width: 12px;
							height: 12px;
							content: '';
							display: block;
							position: absolute;
							bottom: 4px;
							left: 50%;
							background: url(@/assets/index/down.png) no-repeat center center;
							background-size: 12px;
							transform: translateX(-50%);
							z-index: 1;
							transition: all 1s;
						}
						&.active{
							.creater_text{
								max-height: 300px;
							}
							&:after{
								transform:translate(-50%) rotate(180deg);
							}
							
						}
					}
					.creater_text{
						padding: 24px;
						font-size: 12px;
						line-height: 18px;
						color: rgba(171,174,180,1);
						overflow: hidden;
						max-height: 96px;
						transition: all 1s;
						padding-bottom: 0;
					}
				}
			}
			.pc_box{
				display: none;
			}
			.friend_list{
				 padding: 0 17px;
				 padding-top: 52px;
				 width: 100%;
				 margin-bottom: 73px;
				 .title{
					 font-size: 28px;
					 margin-bottom: 40px;
				 }
				 .friend_logos{
					 width: 100%;
					 display: grid;
					 grid-template-columns: repeat(3, 1fr);
					 grid-gap: 8px;
					 position: relative;
					 .logo_img_box{
						width: auto;
					 }
					 .logo_img{
						 width: 100%;
						 height: auto;
						 margin-bottom: 8px;
					 }
				 }
			}
			.list_content_box {
				display: none;
			}
		}
	}
</style>